import { useGateValue } from '@statsig/react-bindings';

const usePeakSeasonOOSMessage = () => {
  return useGateValue('show_peak_season_oos_message');
};

export default usePeakSeasonOOSMessage;
